const ENV =
  process.env.REACT_APP_ENV || process.env.ENV || process.env.NODE_ENV;
console.log({ env_client: ENV });

const API_URL =
  ENV === "production"
    ? "https://dako-eu.herokuapp.com"
    : ENV === "staging"
    ? "https://dako-wyceny-server.herokuapp.com"
    : "http://localhost:4000";

module.exports = {
  API_URL,
  ENV
};
